module.exports = __webpack_public_path__ + "pSIbFAhLWaWz2Kf3O/powered-by-qualia.svg";